<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>アナウンス一覧</h5>
      </div>
      <div class="col-4 d-flex justify-content-end">
        <button id="createAnnounceBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-9">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">内容</th>
              <th scope="col">通知開始</th>
              <th scope="col">通知終了</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(announce, index) in announces" v-bind:key="announce.id">
              <th scope="row">{{ index + 1 }}</th>
              <td style="white-space: pre-wrap;">{{ announce.announce }}</td>
              <td>{{ announce.startAt }}</td>
              <td>{{ announce.endAt }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="modify(announce.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function () {
    return {
      announces: [],
      message: ''
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !==0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/announce/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/announce/modify/'+id))
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          if(isInit){
            this.currentIndex = 0
          }
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.get("/api/announce/management/list", {
            headers: this.headers(accessToken)
          })
          .then(response => {
            this.announces = response.data.data.announces;
          })
          .catch(err => {
            this.message = err.message
          })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch(err => {
        this.message = err.message
      })
    }
  }
}
</script>
<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#createUserGroupBtn {
  float:right;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>